













































// --- Vue & Template imports ---
import { Component, Prop, Vue } from 'vue-property-decorator';

// --- Models ---
import { LoggedInUser } from '@/models/User.model';

// --- Services ---
import AppService from '@/services/app';
import AuthService from '@/services/auth';

// --- Third Party imports ---

@Component
export default class PaymentConfirmed extends Vue {
  hasPaid: boolean = false;

  async beforeMount() {
    // this page will get called by the payment confirmation
    // that means that the User payment should be confirmed. but let's check again 

    // we are not checking auth in the router here because otherwise they will be routed to the Check Router and redirected to Campaign Code immediately
    await AuthService.getLoggedInUser();
    const loggedInUser: LoggedInUser = this.$store.getters['users/loggedInUser'];

    if (!loggedInUser.paid) {
      this.$router.push( { name: 'Register More'} );
    } else {
      this.hasPaid = true;
    }
  }

  startTest() {
    this.$router.push( { name: 'Test'} );
  }
}
